import React from "react";

/** Ledger rows written automatically by the server (e.g. PayU refund webhooks). */
export const isAutoTx = (tx: any): boolean =>
  tx?.automatic === true || tx?.source === "payu_webhook_auto";

export const AutoBadge: React.FC<{ tx: any }> = ({ tx }) =>
  isAutoTx(tx) ? (
    <span
      title="Automatic adjustment made by the system"
      className="text-[10px] bg-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded font-bold uppercase tracking-wide"
    >
      Auto
    </span>
  ) : null;

const LABELS: Record<string, string> = {
  wallet_recharge: "Wallet Recharge",
  order_payment: "Order Payment",
  order_payment_credit: "PayU Payment",
  payu_refund: "Refund to Bank/UPI",
  payu_refund_reversal: "Refund Reversed",
  payu_refund_failed_recredit: "Refund Failed – Returned",
  payu_dashboard_refund_debit: "Refund via PayU",
  order_refund: "Order Refund",
  admin_adjustment: "Adjustment",
  direct_upi_topup: "UPI Top-up (direct)",
};

export const txLabel = (tx: any): string =>
  LABELS[tx?.type] || (tx?.type ? String(tx.type).replace(/_/g, " ") : "Transaction");

/** true when the entry added money to the wallet. */
export const txIsCredit = (tx: any): boolean =>
  tx?.direction ? tx.direction === "credit"
    : typeof tx?.signedAmount === "number" ? tx.signedAmount > 0
      : tx?.type === "wallet_recharge";

export const txDate = (tx: any): string => {
  const t = tx?.createdAt || tx?.date || tx?.timestamp;
  return t?.toDate ? t.toDate().toLocaleDateString() : "Just now";
};
